import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { saDataRetainabilityChartConfig } from '../chartConfigs';

interface DataRetainabilitySaEchartsProps {
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const DataRetainabilitySaEcharts: React.FC<DataRetainabilitySaEchartsProps> = ({ onFullscreenToggle, isFullscreen }) => (
  <SiteCharts config={saDataRetainabilityChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} />
);

export default DataRetainabilitySaEcharts;
